import { Input } from "@synthesis/shared-ui";
import { useWatch } from "react-hook-form";

import { ApplicantStringList } from "./create-application-applicant-form-controls";
import { ApplicantBankSection } from "./create-application-applicant-bank-section";
import { ApplicantContactSection } from "./create-application-applicant-contact-section";
import { ApplicantRegistrationSection } from "./create-application-applicant-registration-section";
import { CreateApplicationFormField, CreateApplicationFormSection } from "../create-application-form-layout";

export const ApplicantPayerSection = () => {
  const payerApplicantType = useWatch({ name: "payerApplicantType" });

  return (
    <>
      <ApplicantRegistrationSection namePrefix="payer" title="Регистрационные реквизиты плательщика" applicantType={payerApplicantType} />
      <ApplicantContactSection namePrefix="payer" title="Контактная информация плательщика" applicantType={payerApplicantType} />

      <CreateApplicationFormSection title="Контактное лицо по вопросам оплаты" required>
        <CreateApplicationFormField label="Контактное лицо (ФИО)" required>
          <Input name="payerPaymentContactFullName" placeholder="Иванов Иван Иванович" />
        </CreateApplicationFormField>

        <CreateApplicationFormField label="Должность" required>
          <Input name="payerPaymentContactPosition" placeholder="Например: финансовый директор" />
        </CreateApplicationFormField>

        <CreateApplicationFormField label="Контактный телефон">
          <ApplicantStringList
            name="payerPaymentContactPhones"
            placeholder="+7 (000) 000 00 00"
            addLabel="Добавить телефон"
            removeLabel="Удалить телефон"
          />
        </CreateApplicationFormField>

        <CreateApplicationFormField label="e-mail для связи">
          <ApplicantStringList
            name="payerPaymentContactEmails"
            placeholder="example@mail.com"
            addLabel="Добавить e-mail"
            removeLabel="Удалить e-mail"
          />
        </CreateApplicationFormField>
      </CreateApplicationFormSection>

      <ApplicantBankSection namePrefix="payer" title="Банковские реквизиты плательщика" />
    </>
  );
};
